module.exports = __webpack_public_path__ + "img/img_target_left_bf.5be9834a.svg";